import React, { Component } from "react";
import { Button } from "semantic-ui-react";
import SRHHeader from "./../index";
import { HeaderLeft, HeaderCenter, HeaderRight, Logo, Title } from "./style.js";
import logo from "./../../../assets/img/logo/logo-white.png";
import { userOperations } from "./../../../redux/user";
import { summaryReportOperations } from "./../../../redux/summaryReport";
import { summaryReportTreeOperations } from "./../../../redux/summaryReportTree";

export default class ObservationsHeader extends Component {
  constructor(props) {
    super(props);
    this.signOut = this.signOut.bind(this);
  }

  signOut() {
    this.props.dispatch(userOperations.signOut());
    this.props.dispatch(summaryReportOperations.clear());
    this.props.dispatch(summaryReportTreeOperations.clear());
  }

  render() {
    const { breadcrumbs } = this.props;
    return (
      <SRHHeader>
        <HeaderLeft>
          <Logo className="logo">
            <img src={logo} alt="" />
          </Logo>
          <Title>
            Observations <br /> Dashboard
          </Title>
        </HeaderLeft>
        <HeaderCenter />
        <HeaderRight>
          <Button primary onClick={this.signOut} style={{ whiteSpace: "nowrap" }}>
            Sign out
          </Button>
        </HeaderRight>
      </SRHHeader>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SRHHeaders/ObservationsHeader/index.jsx